import { Component, Input } from '@angular/core';
import { MessageBox } from '../models/message-box.model';

@Component({
  selector: 'mprd-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.css'],
})
export class MessageBoxComponent {
  @Input() messageBox: MessageBox = {
    description: '',
  };
  @Input() taggingName = '';

  getWrapperClass(messageBox: MessageBox): string {
    let wrapperClass;
    switch (messageBox.type) {
      case 'success':
        wrapperClass = 'rs-msgbox rs-msgbox-success';
        break;
      case 'warning':
        wrapperClass = 'rs-msgbox rs-msgbox-warning';
        break;
      case 'error':
        wrapperClass = 'rs-msgbox rs-msgbox-error';
        break;
      default:
        wrapperClass = 'rs-msgbox';
        break;
    }

    if (messageBox.useNegativeColors) {
      wrapperClass = wrapperClass + ' rs-msgbox-neg';
    }

    return wrapperClass;
  }

  getIconClass(messageBox: MessageBox): string {
    switch (messageBox.type) {
      case 'success':
        return 'icon-Validation-box';
      case 'warning':
        return 'icon-Warning-box';
      case 'error':
        return 'icon-Error-box';
      default:
        return 'icon-Information-box';
    }
  }

  getTitleClass(messageBox: MessageBox): string {
    switch (messageBox.type) {
      case 'success':
        return 'rs-txt-s6 rs-txt-success';
      case 'error':
        return 'rs-txt-s6 rs-txt-error';
      default:
        return 'rs-txt-s6 rs-txt-pp1';
    }
  }
}
